import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CheckAccessToken, StorageGet } from '@mdd/api';
import { PrincipalService } from '../principal.service';
import { createRouterLocation } from './createRouterLocation';
import { ReloginGuard } from './relogin.guard';
import { first } from 'rxjs/operators';

const LAST_PAGE_MAP_KEY = 'lastPageMap';
interface LastPageMap {
    [userId: number]: string;
}

@Injectable()
export class LoginReturnGuard extends ReloginGuard {
    getLastPageMap = new StorageGet<LastPageMap>();
    private checkAccessToken = new CheckAccessToken();

    constructor(
        private router: Router,
        location: Location,
        principal: PrincipalService
    ) {
        super(location, principal);
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (
            super.canLoad() &&
            this.checkAccessToken.execute(createRouterLocation(route, this.router))
        ) {
            this.principal.user.pipe(first((x) => !!x)).subscribe((user) => {
                const lastPageMap = this.getLastPageMap.execute(LAST_PAGE_MAP_KEY);
                let lastPage;
                if (user && user.id) {
                    lastPage = lastPageMap && lastPageMap[user.id];
                }

                let lastPageParts = '';
                let lastDashboard = '';
                if (lastPage) {
                    lastPageParts = lastPage.match(/(.*dashboards)\/(.*?)\//);
                }

                if (lastPageParts != null) {
                    lastDashboard = `/dashboards/${lastPageParts[2]}`;
                } else if (lastPage.includes('/dashboards/')) {
                    lastDashboard = lastPage;
                }

                this.router.navigateByUrl(route.queryParams.return || lastDashboard || '/');
            });

            return false;
        }

        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot): boolean {
        return this.canActivate(route);
    }
}
